<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addClaim.title')" backdrop shadow
            :visible="allowAddClaim" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('safetyShared.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addClaim.recordLabel')" class="text-left mb-0" v-if="showRecordField">
                            <b-form-input v-model="claimPayload.record_no" type="text" :placeholder="$t('addClaim.recordPlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.record_no" class="field-error">
                                {{ errors.record_no[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('addClaim.recordLabel')" class="text-left mb-0" v-else>
                            <b-form-input v-model="lastRecord" disabled type="text" :placeholder="$t('addClaim.recordPlaceholder')" class="unit"
                                required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addClaim.statusLabel') }}</label>
                            <b-form-select v-model="claimPayload.status" class="f-12" :options="statusOptions" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label for="claim-add-datepicker" class="state">{{ $t('addAccident.dateLabel') }}</label>
                            <date-picker v-model="claimPayload.date" :formatter="momentFormat"
                            :range-separator="' - '" @clear="claimPayload.date = ''" :placeholder="$t('safetyShared.selectDate')"
                            class="date-picker-custom" :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.date" class="field-error">
                            {{ errors.date[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.timeLabel') }}</label>
                        <b-form-input type="time" class="f-12" v-model="claimPayload.time"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addClaim.driverLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="claimPayload.driver" :options="driverOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchDriver">
                                <span slot="no-options">
                                    {{ $t('addClaim.searchDriver') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.driver" class="field-error">
                                {{ errors.driver[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.vehicleLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="claimPayload.vehicle" :options="vehicleOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchVehicle">
                                <span slot="no-options">
                                    {{ $t('addAccident.searchVehicle') }}
                                </span>
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.trailerLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="claimPayload.trailer" :options="trailerOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchTrailer">
                                <span slot="no-options">
                                    {{ $t('addAccident.searchTrailer') }}
                                </span>
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.divisionLabel') }}</label>
                            <v-select class="f-12" :clearable="false" :options="allDivisions"
                                v-model="claimPayload.division" :reduce="(option) => option.id" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left">
                         <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('accidentVehicle.typeLabel') }}</label>
                            <b-form-select v-model="claimPayload.type" class="f-12" :options="[{
                                value: '',
                                text: ''
                            },
                            {
                                value: 'Self',
                                text: 'Self'
                            },
                            {
                                value: 'Insurance',
                                text: 'Insurance'
                            },
                            {
                                value: 'Other',
                                text: 'Other'
                            },
                            {
                                value: 'AL',
                                text: 'AL'
                            },
                            {
                                value: 'Cargo',
                                text: 'Cargo'
                            },
                            {
                                value: 'GL',
                                text: 'GL'
                            },
                            {
                                value: 'PD',
                                text: 'PD'
                            },
                            {
                                value: 'OO PD',
                                text: 'OO PD'
                            },
                            {
                                value: 'OO NTL',
                                text: 'OO NTL'
                            },
                            {
                                value: 'OccAcc',
                                text: 'OccAcc'
                            },
                            {
                                value: 'W.C.',
                                text: 'W.C.'
                            }
                            ]" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <div class="text-left select_arrow">
                            <b-form-group :label="$t('addClaim.claimNumberLabel')" class="text-left mb-0">
                                <b-form-input type="text" class="f-12" :placeholder="$t('addClaim.claimNumberPlaceholder')"
                                    v-model="claimPayload.claim_number"></b-form-input>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col md="12" class="text-left mt-3">
                        <label class="state text-left">{{ $t('addClaim.notesLabel') }}</label>
                        <b-form-textarea id="textarea" class="f-12" :placeholder="$t('addClaim.notesPlaceholder')" rows="5"
                            v-model="claimPayload.notes"></b-form-textarea>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('editClaim.accidentsTab') }}</h3>
                    <b-col md="12" sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addClaim.accidentsLabel') }}</label>
                        <v-select class="bg_white w-100 f-12" v-model="claimPayload.accident_number"
                            :options="accidentOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                            @search="searchAccidents">
                            <span slot="no-options">
                                {{ $t('addClaim.searchAccident') }}
                            </span>
                        </v-select>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4 mb-7rem">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.detailsSection') }}</h3>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.addressLabel') }}</label>
                        <b-form-input v-model="claimPayload.address" class="f-12"
                            :placeholder="$t('addAccident.addressPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.cityLabel') }}</label>
                        <b-form-input v-model="claimPayload.city" class="f-12" :placeholder="$t('addAccident.cityPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.stateLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="claimPayload.state" :options="states"
                                item-value="id" item-text="label" :reduce="(option) => option.id">
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.postalCodeLabel') }}</label>
                        <b-form-input v-model="claimPayload.postal_code" class="f-12"
                            :placeholder="$t('addAccident.postalCodePlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.customerLabel') }}</label>
                        <b-form-input v-model="claimPayload.customer" class="f-12"
                            :placeholder="$t('addAccident.customerPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.loadNumberLabel') }}</label>
                        <b-form-input v-model="claimPayload.load_number" class="f-12"
                            :placeholder="$t('addAccident.loadNumberPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addClaim.insuranceLabel') }}</label>
                        <b-form-input v-model="claimPayload.insurance_name" class="f-12"
                            :placeholder="$t('addClaim.insurancePlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addClaim.policyLabel') }}</label>
                        <b-form-input v-model="claimPayload.policy_type" class="f-12"
                            :placeholder="$t('addClaim.policyPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('editClaim.damageValueLabel') }}</label>
                        <b-form-input v-model="claimPayload.damage_value" class="f-12"
                            :placeholder="$t('editClaim.damageValuePlaceholder')"></b-form-input>
                    </b-col>
                </b-row>
                <div class="sidebar-footer position-fixed">
                    <div class="text-right modal-footer border-0 p-0">
                        <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()"
                            variant="secondary">{{ $t('safetyShared.cancel') }}</b-button>
                        <b-button class="mx-0 h-40px px-2 mr-3" @click="onAddNewClaim(true)"
                            variant="outline-primary">{{ $t('safetyShared.saveAndOpen') }}</b-button>
                        <b-button class="mx-0 h-40px w-100px" @click="onAddNewClaim()" variant="primary">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: { vSelect, DatePicker },
    name: "AddClaim",
    props: {
        allowAddClaim: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            "userCompany",
            "allEquipments",
            "allDrivers",
            "allCountries",
            "divisions"
        ]),
        statusOptions() {
            return [
                { value: 'New', text: this.$t('safetyShared.statusNew') },
                { value: 'Open', text: this.$t('safetyShared.statusOpen') },
                { value: 'Closed', text: this.$t('safetyShared.statusClosed') },
                { value: 'Urgent', text: this.$t('safetyShared.statusUrgent') },
            ];
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    data() {
        return {
            errors: {},
            states: [],
            claimID: null,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            showRecordField:false,
            claimPayload: {
                address: "",
                city: "",
                claim_number: "",
                postal_code: "",
                state: null,
                driver: null,
                status: "New",
                record_no: "",
                vehicle: null,
                trailer: null,
                date: null,
                time: null,
                notes: "",
                type: "",
                policy_type: "",
                insurance_name: "",
                damage_value: "",
                accident_number: "",
                customer: "",
                load_number: "",
                division: null
            },
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            accidentOptions: [],
            lastRecord:null
        }
    },
    methods: {
        ...mapActions([
            "getFilteredEquipments",
            "getFilteredDrivers",
            "setLoader",
            "addClaim",
            "setNotification",
            "getAllCountries",
            "getAllAccidentData",
            "getLastRecord"
        ]),
        async getCountries() {
            await this.getAllCountries();
            const countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            this.claimPayload.state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
        },
        async searchAccidents(searchText) {
            let options = []
            const url = `sort_field=record_no&search_field=${searchText}&sort_order=desc&page=1&page_size=10`
            const data = await this.getAllAccidentData(url);
            data.records.forEach((x) => {
                options.push({
                    id: x.record_no.toString(),
                    label: x.record_no.toString(),
                });
            });
            this.accidentOptions = this.accidentOptions.concat(options)
            this.accidentOptions = [...new Map(this.accidentOptions.map(item => [item['id'], item])).values()]
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddNewClaim(openClaim = false) {
            try {
                const nullKeys = this.checkNullValues({
                    driver: this.claimPayload.driver,
                    date: this.claimPayload.date,
                    ...this.showRecordField ? { record_no: this.claimPayload.record_no } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if (!this.showRecordField) delete this.claimPayload.record_no
                    const record = await this.addClaim({ ...this.claimPayload, company: this.userCompany, accident_number: this.claimPayload.accident_number ? this.claimPayload.accident_number : '', date: moment(this.claimPayload.date).format('YYYY-MM-DD') })
                    await this.setNotification({
                        msg: this.$t('addClaim.added'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false);
                    if (openClaim) this.$emit("claimAdded", record)
                    else this.$emit("claimAdded", null)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }

        },
        resetPopup() {
            this.claimPayload = {
                address: "",
                city: "",
                claim_number: "",
                postal_code: "",
                state: null,
                driver: null,
                status: "New",
                record_no: "",
                vehicle: null,
                trailer: null,
                date: null,
                time: null,
                notes: "",
                type: "",
                policy_type: "",
                insurance_name: "",
                damage_value: "",
                accident_number: "",
                customer: "",
                load_number: "",
                division: null
            },
                this.errors = {}
            this.driverOptions = [],
                this.vehicleOptions = [],
                this.trailerOptions = []
            this.accidentOptions = []
            this.$emit("close")
        },
       async searchDriver(searchText) {
            if(searchText && searchText.length >=2){
            let options = []
            const driverRecords = await this.getFilteredDrivers(searchText);
            driverRecords.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.name,
                });
            });
            this.driverOptions = this.driverOptions.concat(options)
            this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
        } 
        },
        async searchVehicle(searchText) {
            if (searchText) {
            let options = [];
            const vehicleRecords =  await this.getFilteredEquipments({unit_no:searchText, type:"Vehicle"});
            vehicleRecords.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                });
            });
            this.vehicleOptions = this.vehicleOptions.concat(options)
            this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
        } 
        },
        async searchTrailer(searchText) {
            if (searchText) {
            let options = [];
            const trailerRecords = await this.getFilteredEquipments({unit_no:searchText, type:"Trailer"});
            trailerRecords.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                });
            });
            this.trailerOptions = this.trailerOptions.concat(options)
            this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
        } 
        },
    },
    watch: {
        async allowAddClaim() {
            if(this.allowAddClaim){
                this.setLoader(true)
            const lastItemRecord = await this.getLastRecord({
                company_id: this.userCompany,
                query: `model_name=safetyclaim`
            })
            if (lastItemRecord) this.lastRecord = lastItemRecord + 1;
            else this.showRecordField = true
            this.setLoader(false)
        }
        }
    },
    async mounted(){
        await this.getCountries();
    }
}
</script>